module.exports = "\r\n<div class=\"container-fluid background h-100\">\r\n    <div class=\"d-flex flex-column align-items-center justify-content-center h-100 p-5\">\r\n<!--         <div class=\"user_card_header\">\r\n            <h1 class=\"p-3 text-secondary text-sm-center\"><strong>App Colokial</strong></h1>\r\n        </div> -->\r\n        <router-outlet><app-spinner></app-spinner></router-outlet>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/auth-layout/auth-layout.component.html
// module id = ./src/app/layouts/auth-layout/auth-layout.component.html
// module chunks = main